module.exports = __webpack_public_path__ + "assets/fonts/Icon-Lohnstueckkosten.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Icon-Lohnstueckkosten.svg
// module id = 524
// module chunks = 0